import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { GrispiInputProps } from '..';
import ConditionDateTimeInput from '../../AdminPage/ConditionInput/ConditionDateTimeInput';
import GrispiInputAnniversaryController from '../GrispiInputAnniversaryController';
import GrispiInputContainer from '../GrispiInputContainer';

export type GrispiDateInputProps = Omit<GrispiInputProps<'DATE' | 'DATE_TIME'>, 'options' | 'isNewValueAllowed'>;

const createDayjsObject = (value: number) => dayjs(value);
const isDayjsObject = (value: dayjs.Dayjs) => dayjs.isDayjs(value);

const transformDayjsValue = (value: dayjs.Dayjs) => {
    if (isDayjsObject(value)) return value.valueOf().toString();
    return null;
};

const transformFormValue = (value: string) => {
    if (typeof value === 'string' && !Number.isNaN(+value)) return createDayjsObject(+value);
};

const GrispiDateInput = ({
    antdProps,
    conditionInput,
    containerProps,
    onChange,
    operator,
    value,
    disabled,
    ...rest
}: GrispiDateInputProps) => {
    const [datePickerElementId, setDatePickerElementId] = useState(null);

    useEffect(() => {
        const id = Math.floor(Math.random() * 10000);
        setDatePickerElementId(`antd-assignee-input-${id}`);
    }, []);

    useEffect(() => {
        if (!datePickerElementId) {
            return;
        }

        const sidebar = document.querySelector(
            'div.tab-content-container section.ant-layout.ant-layout-has-sider > aside.ant-layout-sider'
        );

        const onScroll = () => {
            const input: HTMLElement = document.getElementById(datePickerElementId);
            if (!input) return;

            const cascader: HTMLElement = input.closest('.custom-field-item')?.querySelector('.antd-datepicker-fixed');
            const rect: DOMRect = input.getBoundingClientRect();

            cascader?.style?.setProperty('top', 7 + rect.y + rect.height + 'px');
        };

        sidebar?.addEventListener('scroll', onScroll);
        document.addEventListener('scroll', onScroll);

        return () => {
            sidebar?.removeEventListener('scroll', onScroll);
            document.removeEventListener('scroll', onScroll);
        };
    }, [datePickerElementId]);

    return (
        <GrispiInputContainer {...containerProps}>
            {conditionInput ? (
                <GrispiInputAnniversaryController value={value} onChange={onChange} disabled={disabled}>
                    <ConditionDateTimeInput
                        antdProps={antdProps}
                        onChange={onChange}
                        value={value}
                        operator={operator}
                        disabled={disabled}
                        {...rest}
                    />
                </GrispiInputAnniversaryController>
            ) : (
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                <DatePicker
                    id={datePickerElementId}
                    popupClassName="antd-datepicker-fixed"
                    format="DD/MM/YYYY"
                    {...antdProps}
                    onChange={(v: dayjs.Dayjs) => onChange(transformDayjsValue(v))}
                    value={transformFormValue(value)}
                    placement="bottomRight"
                    disabled={disabled}
                    {...rest}
                />
            )}
        </GrispiInputContainer>
    );
};

export default GrispiDateInput;
